<script setup lang="ts">

import { faCalendarPlus, faPenToSquare } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useDisciplineWeeklyScheduleActions } from '../model/discipline-weekly-schedule-actions.hook'

defineOptions({
  name: 'DisciplineWeeklyScheduleActions',
})

defineProps<{
  disabled: boolean
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  toggle,
  openChange,
  openSetupLessons,
} = useDisciplineWeeklyScheduleActions()
</script>

<template>
  <div
    ref="containerRef"
    class="discipline-weekly-schedule-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      title="Weekly schedule actions"
      :tooltip-text="disabled ? 'Create a weekly schedule first' : ''"
      :disabled="disabled"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="discipline-weekly-schedule-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Change weekly schedule"
          color="blue"
          :prepend-icon="faPenToSquare"
          @click="openChange"
        />
        <AppDropdownItem
          text="Unscheduled lessons setup"
          color="blue"
          :prepend-icon="faCalendarPlus"
          @click="openSetupLessons"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineWeeklyScheduleActions.scss" />
